// import type { Action } from "$lib/types/actions"
export const swipe = (node: HTMLElement) => {
  let touchstartX = 0;
  let touchendX = 0;
  let touchThreshold = 0;
  let minimumSwipe = 150;

  const handleTouchStart = (event: TouchEvent) => {
    event.stopPropagation();
    touchstartX = event.changedTouches[0].screenX;
  };

  const handleTouchEnd = (event: TouchEvent) => {
    event.stopPropagation();
    touchendX = event.changedTouches[0].screenX;
    handleGesture();
  };

  const handleMove = (event: TouchEvent) => {
    let distance =
      Math.round(10 * (touchstartX - event.changedTouches[0].screenX) * 0.1) /
      10;
    node.dispatchEvent(new CustomEvent("mover", { detail: { distance } }));
  };

  node.addEventListener("touchstart", handleTouchStart);
  node.addEventListener("touchend", handleTouchEnd);
  node.addEventListener("touchmove", handleMove);

  function handleGesture() {
    if (touchendX <= touchstartX) {
      console.log("Swiped left");

      // calculate how big of swipe it was
      touchThreshold = touchstartX - touchendX;
      console.log("length of swipe: " + touchThreshold);

      // only fire function if the swipe was worth it
      if (touchThreshold > minimumSwipe) {
        node.dispatchEvent(new CustomEvent("next"));
      }
    } else {
      node.dispatchEvent(new CustomEvent("resetter"));
    }

    if (touchendX >= touchstartX) {
      console.log("Swiped right");

      // calculate how big of swipe it was
      touchThreshold = touchendX - touchstartX;

      if (touchThreshold > minimumSwipe) {
        node.dispatchEvent(new CustomEvent("previous"));
      }
    } else {
      node.dispatchEvent(new CustomEvent("resetter"));
    }
  }

  return {
    destroy() {
      node.removeEventListener("touchstart", handleTouchStart);
      node.removeEventListener("touchend", handleTouchEnd);
    },
  };
};
